<dspx-card-set-base-form
          [fieldTypeReplacements]="fieldTypeReplacements"
          [formServiceEndpoint]="formServiceEndpoint"
          [templateId]="templateId"
          [versionNo]="versionNo"
          [entityId]="id"
          [model]="model"
          formName="VPTAS Nominated Patient Details"
          (onFormLoad)="formLoaded($event)"
          (onDialogSubmit)="handleDialogButtonClick($event, activeDialog)"
          (onSave)="save($event)"
          (onCancel)="cancel()"
          (onModelChange)="modelChanged($event)">
</dspx-card-set-base-form>
